import script from "./HomeComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeComponent.vue?vue&type=style&index=0&id=6f3b4ad8&lang=css"

const __exports__ = script;

export default __exports__